import React from 'react'
import { Cell } from 'rsuite-table'
import './PriorityCell.scss'

type RowData = {
  [key: string]: string | boolean
}

type PriorityCellProps = {
  rowData?: RowData,
  dataKey: string
}

const PriorityCell: React.FC<PriorityCellProps> = ({
  rowData,
  dataKey,
  ...props
}) => {
  const priority = rowData?.[dataKey] as string | undefined
  const lowerCasePriority = priority ? priority.toLowerCase() : ''

  return (
    <Cell {...props}>
      <span className={`priority-badge priority-${lowerCasePriority}`}>
        {priority}
      </span>
    </Cell>
  )
}

export default PriorityCell
